import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";

const AIDowntimePopup = forwardRef(({ style, closeReq = true }, ref) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    openPopup: () => setOpen(true),
    closePopup: () => setOpen(false),
  }));

  return (
    <Modal
      open={open}
      disablePortal
      hideBackdrop
      disableEscapeKeyDown
      onClose={() => {}}
      sx={{
        position: "absolute",
        inset: style?.inset ? style?.inset : 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)",
        zIndex: 11,
      }}
    >
      <Box
        sx={{
          p: 3.5,
          borderRadius: 3,
          backgroundColor: "#fff",
          boxShadow: "0 8px 30px rgba(108, 63, 196, 0.15)",
          textAlign: "center",
          maxWidth: 420,
          mx: "auto",
          position: "relative",
          border: "1.5px solid #ffd54f",
        }}
      >
        {closeReq && (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              "&:hover": { color: "#6c3fc4" },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Box sx={{ mb: 1.5, display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              p: 1.5,
              borderRadius: "50%",
              backgroundColor: "#fff8e1",
              border: "1px solid #ffe082",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BuildCircleOutlinedIcon sx={{ fontSize: 44, color: "#ffa000" }} />
          </Box>
        </Box>
        <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 700, color: "#4B2A99" }}>
          AI Service Maintenance
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, lineHeight: 1.6 }}>
          Our AI services are currently undergoing maintenance or temporary downtime.
          We are working to restore full functionality and will be back up soon! Please try again shortly.
        </Typography>
        {closeReq && (
        <Button
          className="mpl-primary-btn"
          variant="contained"
          onClick={handleClose}
          sx={{
            textTransform: "none",
            px: 4,
            borderRadius: 2,
            backgroundColor: "#6c3fc4",
            "&:hover": { backgroundColor: "#4B2A99" },
            boxShadow: "0 4px 12px rgba(255, 160, 0, 0.25)",
          }}
        >
          Got It
        </Button>)}
      </Box>
    </Modal>
  );
});

export default AIDowntimePopup;
